import { render } from "./CursorBase.vue?vue&type=template&id=161b8474"
import script from "./CursorBase.vue?vue&type=script&setup=true&lang=js"
export * from "./CursorBase.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/scripts/common/sideBars/design/cursors/CursorBase.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "161b8474"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('161b8474', __exports__)) {
    api.reload('161b8474', __exports__)
  }
  
  module.hot.accept("./CursorBase.vue?vue&type=template&id=161b8474", () => {
    api.rerender('161b8474', render)
  })

}


export default __exports__